import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Heading.module.styl";

function Heading({ children, size, color, className, name }) {
    const classes = cx(styles.header, styles[`color_${color}`], className);

    if (size === "h1") {
        return (
            <h1 className={classes} data-test-name={name}>
                {children}
            </h1>
        );
    }

    if (size === "h2") {
        return (
            <h2 className={classes} data-test-name={name}>
                {children}
            </h2>
        );
    }

    if (size === "h3") {
        return (
            <h3 className={classes} data-test-name={name}>
                {children}
            </h3>
        );
    }

    return null;
}

Heading.propTypes = {
    size: PropTypes.oneOf(["h1", "h2", "h3"]).isRequired,
    color: PropTypes.oneOf(["dark-blue", "dark-gray"]).isRequired,
    className: PropTypes.string,
    name: PropTypes.string,
};

Heading.defaultProps = {
    color: "dark-blue",
};

export default Heading;
